<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-22 11:44:44
 * @LastEditors: guozhixion xiaoguo4072@163.com
 * @LastEditTime: 2022-05-09 16:28:58
 * @FilePath: /privacy-web/src/components/PrivacyProtect/ManageSystemContentItem.vue
-->
<template>
  <div
    class="Manage-system-content-item-main"
    :class="{ 'Manage-system-content-item-main-mobile': isMobile }"
  >
    <div class="title">{{ data.title }}</div>
    <div class="names">
      <span>{{ data.oneName }}</span>
      <span>{{ data.twoName }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "ManageSystemContentItem",
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
.Manage-system-content-item-main {
  &:nth-child(2) {
    margin-top: calc($multiple * 47px);
  }
}
.title {
  font-size: calc($multiple * 20px);
  font-family: PingFangTC-Medium, PingFangTC;
  font-weight: 500;
  color: #000000;
  line-height: calc($multiple * 28px);
  letter-spacing: 1px;
}
.names {
  /* height: 0.83rem; */
  font-size: calc($multiple * 16px);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.57);
  line-height: calc($multiple * 43px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding-left: calc($multiple * 15px);
  margin-top: calc($multiple * 37px);
}
.names::before {
  content: "";
  position: absolute;
  top: calc($multiple * 8px);
  top: 12px;
  left: 0;
  width: calc($multiple * 5px);
  height: 70%;
  background: linear-gradient(180deg, #4db0ff 0%, #81aaff 100%);
  border-radius: 3px;
}
.Manage-system-content-item-main-mobile {
  &:nth-child(2) {
    margin-top: 1.76rem;
  }
  /* margin-top: 1.43rem; */
  .title {
    font-size: 0.82rem;
    line-height: 1.13rem;
    letter-spacing: 0.03rem;
  }
  .names {
    height: 2rem;
    font-size: 0.61rem;
    line-height: 0.98rem;
    padding-left: 0.36rem;
    margin-top: 1.08rem;
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      width: 0.1rem;
      transform: translateY(-50%);
      height: 80%;
      background: linear-gradient(180deg, #4db0ff 0%, #81aaff 100%);
      border-radius: 1px;
    }
  }
}
</style>
